import { makeStyles } from '@material-ui/core';
import { backgroundColorLogin } from 'app/utils/coresUtil';

export const layoutLoginStyles = makeStyles((theme) => ({
  leftContentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    overflow: 'hidden',
    padding: '1.6rem',
    backgroundColor: backgroundColorLogin,
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '2.4rem',
    },
  },
  leftContent: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      flex: '1 1',
      padding: '12.8rem',
      textAlign: 'left',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '1.6rem',
      textAlign: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      display: 'flex',
    },
  },
  card: {
    width: '100%',
    maxWidth: '40rem',
    [theme.breakpoints.up('md')]: {
      borderRadius: 0,
      margin: 0,
    },
    [theme.breakpoints.down('sm')]: {
      marginLeft: 'auto',
      marginRight: 'auto',
      margin: '1.6rem',
      borderRadius: '2rem',
    },
  },
  cardContent: {
    displayFlex: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '4.8rem',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '1.6rem',
    },
  },
}));
